import type { SVGProps } from 'react'

const LocationInsightsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_170_27635)">
      <path
        d="M52.5 24.9961C52.5 42.4961 30 57.4961 30 57.4961C30 57.4961 7.5 42.4961 7.5 24.9961C7.5 19.0287 9.87053 13.3058 14.0901 9.08619C18.3097 4.86662 24.0326 2.49609 30 2.49609C35.9674 2.49609 41.6903 4.86662 45.9099 9.08619C50.1295 13.3058 52.5 19.0287 52.5 24.9961Z"
        stroke="black"
        strokeWidth="2.22222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1609 33.6336C34.9559 34.3561 34.0003 35.667 34.0003 37.2603V38C34.0003 40.2091 32.2095 42 30.0003 42C27.7912 42 26.0003 40.2091 26.0003 38V37.2603C26.0003 35.667 25.0448 34.3561 23.8397 33.6336C20.3387 31.5346 18.0003 27.7064 18.0003 23.3333C18.0003 16.7059 23.3729 11.3333 30.0003 11.3333C36.6277 11.3333 42.0003 16.7059 42.0003 23.3333C42.0003 27.7064 39.6619 31.5346 36.1609 33.6336Z"
        stroke="#0066FF"
        strokeWidth="2.66667"
      />
      <line
        x1="25.5557"
        y1="36.6662"
        x2="34.4446"
        y2="36.6662"
        stroke="#0066FF"
        strokeWidth="2.22222"
      />
    </g>
    <defs>
      <clipPath id="clip0_170_27635">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default LocationInsightsIcon
